import { Link, useLocation, useParams, useSearchParams } from "react-router-dom";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import GetPrice from "../Functions/GetPrice";
import {
  CapitalizeAllWords,
  convertToPersian,
  NumToFa,
  capitalizeFirstLetters,
  sortSearchFilter,
  formatPrice,
} from "../Functions/TextTransform";
import WebPImageTag from "../Functions/WebPImage";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import OverlayContainer from "../Components/OverlayContainer";
import { Accordion, AccordionContext, useAccordionButton } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import { useMediaQuery } from "react-responsive";
import * as client from "../Services/client";

import { imgUrl } from "../config/api";

const processTowelProductsResponse = (products) => {
  const productData = {};
  products.forEach((obj) => {
    const groupKey = `${obj.DesignCode}:${obj.SewingModelEnName}`;
    if (!productData[groupKey]) {
      productData[groupKey] = [];
    }
    productData[groupKey].push(obj);
  });

  const tempObj = {};
  const productCollection = {};
  const designColorsTemp = {};

  Object.keys(productData).forEach((key) => {
    const tempFiltered = productData[key].filter(
      (value, index, self) => index === self.findIndex((o) => o.ColorId === value.ColorId)
    );

    tempFiltered.forEach((obj) => {
      const productCollectionKey = `${obj.DesignCode}:${obj.SewingModelEnName}:${obj.ColorId}`;

      if (!tempObj[productCollectionKey]) {
        tempObj[productCollectionKey] = productData[key];
      }
      if (!productCollection[productCollectionKey]) {
        productCollection[productCollectionKey] = productData[key]
          .filter((obj2) => obj2.ColorId === obj.ColorId)
          .map((x) => x.ProductId);
      }
      if (!designColorsTemp[productCollectionKey]) {
        designColorsTemp[productCollectionKey] = tempFiltered.map((item) => item.ProductId);
      }
    });
  });

  return { tempObj, productCollection, designColorsTemp };
};

const buildSelectedFiltersArray = (queryObj) => {
  const tempArr = [];
  Object.keys(queryObj).forEach((key) => {
    queryObj[key].forEach((id) => {
      if (id) {
        tempArr.push({ id, filter: key });
      }
    });
  });
  return tempArr;
};

const isActiveColorProduct = (activeColorValue, productId) => {
  if (Array.isArray(activeColorValue)) {
    return activeColorValue.includes(productId);
  }
  return activeColorValue === productId;
};

const useScrollToTopOnPageLoad = (pageLanguage, getCats, location) => {
  useEffect(() => {
    if (pageLanguage !== "") {
      getCats();
    }
    window.scrollTo(0, 0);
  }, [pageLanguage, location.pathname]);
};

const useHandleScrollEvents = (isTabletOrMobile, fixedDiv2, setOffset) => {
  useEffect(() => {
    const DESKTOP_FILTER_TOP_THRESHOLD = 179;

    const onScroll = () => {
      if (!fixedDiv2.current) return;

      if (isTabletOrMobile) {
        if (fixedDiv2.current.offsetTop < window.pageYOffset) {
          setOffset(true);
        } else {
          setOffset(false);
        }
      } else {
        const filterBarTop = fixedDiv2.current.getBoundingClientRect().top;

        if (filterBarTop < DESKTOP_FILTER_TOP_THRESHOLD) {
          setOffset(true);
        } else {
          setOffset(false);
        }
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [isTabletOrMobile, setOffset]);
};

function ProductsTowel() {
  const { t } = useTranslation();
  const location = useLocation();
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname
      .split("")
      .slice(1, 3)
      .join("")
  );
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 923px)" });
  const { catID } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const fixedDiv = useRef(null);
  const fixedDiv2 = useRef(null);
  const fixedDiv3 = useRef(null);
  const [offset, setOffset] = useState(false);
  const firstRender = useRef(true);
  const prevPathnameRef = useRef(location.pathname);
  const routeRef = useRef({ pathname: location.pathname, catID });
  const productsRequestIdRef = useRef(0);
  const [catObject, setCatObject] = useState({});
  const [catProducts, setCatProducts] = useState({});
  const [activeColor, setActiveColor] = useState({});
  const [designColors, setDesignColors] = useState({});
  const [changeColor, setChangeColor] = useState({
    key: undefined,
    id: undefined,
    carousel: undefined,
  });
  const [catProductsList, setCatProductsList] = useState([]);
  const [productFilters, setProductFilters] = useState({});
  const [showAllFilters, setShowAllFilters] = useState(false);
  const [filterColors, setFilterColors] = useState([]);
  const [filterPatterns, setFilterPatterns] = useState([]);
  const [filterTypes, setFilterTypes] = useState([]);
  const [filterPrices, setFilterPrices] = useState([]);
  const [filterHangingStyle, setFilterHangingStyle] = useState([]);
  const [filterOpacity, setFilterOpacity] = useState([]);
  const [filterSize, setFilterSize] = useState([]);
  const [filterLiningType, setFilterLiningType] = useState([]);
  const [filterProductSize, setFilterProductSize] = useState([]);
  const [filterMaterial, setFilterMaterial] = useState([]);
  const [sewingColors2, setSewingColors2] = useState([]);
  const [sewingPatterns2, setSewingPatterns2] = useState([]);
  const [sewingTypes2, setSewingTypes2] = useState([]);
  const [sewingPrices2, setSewingPrices2] = useState([]);
  const [sewingOpacity2, setSewingOpacity2] = useState([]);
  const [sewingSize2, setSewingSize2] = useState([]);
  const [sewingLiningType, setSewingLiningType] = useState([]);
  const [sewingHangingStyle2, setSewingHangingStyle2] = useState([]);
  const [filterEndUse, setFilterEndUse] = useState([]);
  const [sewingEndUse2, setSewingEndUse2] = useState([]);
  const filterCheckboxes = useRef({
    colors: [],
    patterns: [],
    type: [],
    price: [],
    opacity: [],
    size: [],
    hangingStyle: [],
    ProductSize: [],
    Material: [],
    colors2: [],
    patterns2: [],
    types2: [],
    prices2: [],
    Opacity2: [],
    size2: [],
    LiningType2: [],
    HangingStyle2: [],
    ProductSize2: [],
    Material2: [],
    application: [],
    endUse2: [],
  });
  const [showMoreFilterTrigger, setShowMoreFilterTrigger] = useState(undefined);
  const [showMoreFilter, setShowMoreFilter] = useState({
    colors: false,
    patterns: false,
    type: false,
    price: false,
    opacity: false,
    size: false,
    Lining: false,
    hangingStyle: false,
    ProductSize: false,
    Material: false,
    application: false,
  });
  const [filterChangedBool, setFilterChangedBool] = useState(false);
  const [filterChanged, setFilterChanged] = useState({
    filter: "",
    filter_id: undefined,
    isDelete: false,
    UrlName: "",
  });
  const [clearFilter, setClearFilter] = useState(undefined);
  const [baseFilter, setBaseFilter] = useState(undefined);
  const [selectedFilters, setSelectedFilters] = useState(undefined);
  const [selectedFiltersList, setSelectedFiltersList] = useState([]);
  const [columnCountWidth, setColumnCountWidth] = useState(null);
  const [selectedSort, setSelectedSort] = useState(undefined);
  const maxColors = window.innerWidth >= 924 ? 4 : 3;

  const isStaleRoute = (requestPathname, requestCatID) =>
    routeRef.current.pathname !== requestPathname || routeRef.current.catID !== requestCatID;

  const getCats = async () => {
    const requestPathname = location.pathname;
    const requestCatID = catID;
    try {
      const { data } = await client.getCats(catID);
      if (isStaleRoute(requestPathname, requestCatID)) {
        return;
      }
      if (data?.Link) {
        setCatObject(data);
        setColumnCountWidth(data.ColumnCount);
      } else {
        setCatObject({});
      }
    } catch (error) {
      if (isStaleRoute(requestPathname, requestCatID)) {
        return;
      }
      console.error(error);
      setCatProductsList([<h1>{t("No Products")}</h1>]);
    }
  };

  function getCatProducts(filtersOverride) {
    const requestId = ++productsRequestIdRef.current;
    const requestPathname = location.pathname;
    const requestCatID = catID;
    const linkString = catObject.Link || "";
    const linkArray = linkString.split(",").filter((item) => item && item.trim());
    if (!linkArray.length) {
      return;
    }

    let paramObj = {
      group: linkArray,
    };

    const activeSelectedFilters = filtersOverride ?? selectedFilters ?? [];

    let tempSelectedFilters = {
      color: activeSelectedFilters.filter((obj) => obj["filter"] === "colors") || [],
      patterns: activeSelectedFilters.filter((obj) => obj["filter"] === "patterns") || [],
      type: activeSelectedFilters.filter((obj) => obj["filter"] === "type") || [],
      price: activeSelectedFilters.filter((obj) => obj["filter"] === "price") || [],
      opacity: activeSelectedFilters.filter((obj) => obj["filter"] === "opacity") || [],
      size: activeSelectedFilters.filter((obj) => obj["filter"] === "size") || [],
      Lining: activeSelectedFilters.filter((obj) => obj["filter"] === "Lining") || [],
      hangingStyle: activeSelectedFilters.filter((obj) => obj["filter"] === "hangingStyle") || [],
      ProductSize: activeSelectedFilters.filter((obj) => obj["filter"] === "ProductSize") || [],
      Material: activeSelectedFilters.filter((obj) => obj["filter"] === "Material") || [],
      application: activeSelectedFilters.filter((obj) => obj["filter"] === "application") || [],
    };

    if (tempSelectedFilters["color"].length) {
      paramObj["color"] = tempSelectedFilters["color"].map((obj) => obj["id"]);
    }
    if (tempSelectedFilters["patterns"].length) {
      paramObj["pattern"] = tempSelectedFilters["patterns"].map((obj) => obj["id"]);
    }
    if (tempSelectedFilters["type"].length) {
      paramObj["designType"] = tempSelectedFilters["type"].map((obj) => obj["id"]);
    }
    if (tempSelectedFilters["price"].length) {
      paramObj["price"] = tempSelectedFilters["price"].map((obj) => obj["id"]);
    }
    if (tempSelectedFilters["opacity"].length) {
      paramObj["opacity"] = tempSelectedFilters["opacity"].map((obj) => obj["id"]);
    }
    if (tempSelectedFilters["hangingStyle"].length) {
      paramObj["sewingModel"] = tempSelectedFilters["hangingStyle"].map((obj) => obj["id"]);
    }
    if (tempSelectedFilters["ProductSize"].length) {
      paramObj["productSizes"] = tempSelectedFilters["ProductSize"].map((obj) => obj["id"]);
    }
    if (tempSelectedFilters["Material"].length) {
      paramObj["materials"] = tempSelectedFilters["Material"].map((obj) => obj["id"]);
    }
    if (tempSelectedFilters["size"].length) {
      paramObj["size"] = tempSelectedFilters["size"].map((obj) => obj["id"]);
    }
    if (tempSelectedFilters["Lining"].length) {
      paramObj["liningType"] = tempSelectedFilters["Lining"].map((obj) => obj["id"]);
    }
    if (tempSelectedFilters["application"].length) {
      paramObj["application"] = tempSelectedFilters["application"].map((obj) => obj["id"]);
    }

    const transformParamObj = (obj) => {
      const newObj = {};
      for (const key in obj) {
        if (Array.isArray(obj[key])) {
          newObj[key] = obj[key].map((item) => item.replace(/_/g, " "));
        } else {
          newObj[key] = obj[key];
        }
      }
      return newObj;
    };

    paramObj = transformParamObj(paramObj);
    const hasActiveFilters = Object.entries(paramObj).some(
      ([key, value]) =>
        key !== "group" && Array.isArray(value) && value.some((v) => v && String(v).trim())
    );
    const { pathname, search } = window.location;
    let updatedURL = pathname;

    if (hasActiveFilters) {
      if (!pathname.includes("/filters")) {
        updatedURL = `${pathname}/filters`;
      }
    } else if (pathname.includes("/filters")) {
      updatedURL = pathname.replace("/filters", "");
    }
    let resultURL = sortSearchFilter(search);
    const newURL =
      !resultURL && resultURL !== "?=undefined"
        ? `${updatedURL}${resultURL}`
        : `${updatedURL}${search}`;

    window.history.replaceState(null, "", newURL);

    client
      .getCatProduct(paramObj)
      .then((response) => {
        if (requestId !== productsRequestIdRef.current) {
          return;
        }
        if (isStaleRoute(requestPathname, requestCatID)) {
          return;
        }
        if (response.data) {
          const products = response.data["Products"] || [];
          const { tempObj, productCollection, designColorsTemp } =
            processTowelProductsResponse(products);

          if (Object.keys(tempObj).length) {
            setCatProducts(tempObj);
            setActiveColor(productCollection);
            setDesignColors(designColorsTemp);
          } else {
            setCatProducts({});
            setActiveColor({});
            setDesignColors({});
            setCatProductsList([<h1>{t("No Products")}</h1>]);
          }

          let Colors = response.data["Filters"]["Colors"] || [];
            let tempColors = {
              en: [],
              fa: [],
            };
            let promiseArr2 = [];
            if (Colors.length) {
              Colors.sort((a, b) => (a["ColorENName"] || "").localeCompare(b["ColorENName"] || ""))
                .filter((obj) => obj["Count"] !== 0)
                .forEach((obj, index) => {
                  promiseArr2[index] = new Promise((resolve, reject) => {
                    tempColors["en"][index] = {
                      value: obj["ColorId"],
                      label: obj["ColorENName"],
                      UrlName: obj["UrlName"],
                      fa_name: obj["ColorName"],
                    };
                    tempColors["fa"][index] = {
                      value: obj["ColorId"],
                      label: obj["ColorName"],
                      UrlName: obj["UrlName"],
                      fa_name: obj["ColorName"],
                    };
                    resolve();
                  });
                });
            }

            let price = response.data["Filters"]["PriceLevels"] || [];
            let tempPriceLevels = {
              en: [],
              fa: [],
            };
            let promiseArr3 = [];
            if (price.length) {
              price
                .sort((a, b) => (a["LevelEnTitle"] || "").localeCompare(b["LevelEnTitle"] || ""))
                .filter((obj) => obj["Count"] !== 0)
                .forEach((obj, index) => {
                  promiseArr3[index] = new Promise((resolve, reject) => {
                    tempPriceLevels["en"][index] = {
                      value: obj["ProductPriceLevelId"],
                      label: obj["LevelEnTitle"],
                      UrlName: obj["UrlName"],
                    };
                    tempPriceLevels["fa"][index] = {
                      value: obj["ProductPriceLevelId"],
                      label: obj["LevelTitle"],
                      UrlName: obj["UrlName"],
                    };
                    resolve();
                  });
                });
            }

            let DesignPattern =
              response.data["Filters"]?.TypeFilters?.find((x) => x.FilterName === "DesignPattern")
                ?.Values || [];
            let tempDesignPattern = {
              en: [],
              fa: [],
            };
            let promiseArr4 = [];
            if (DesignPattern.length) {
              DesignPattern.sort((a, b) => (a["EnTitle"] || "").localeCompare(b["EnTitle"] || ""))
                .filter((obj) => obj["Count"] !== 0)
                .forEach((obj, index) => {
                  promiseArr4[index] = new Promise((resolve, reject) => {
                    tempDesignPattern["en"][index] = {
                      value: obj["Value"],
                      label: obj["EnTitle"],
                      UrlName: obj["UrlName"],
                    };
                    tempDesignPattern["fa"][index] = {
                      value: obj["Value"],
                      label: obj["Title"],
                      UrlName: obj["UrlName"],
                    };
                    resolve();
                  });
                });
            }

            let DesignType =
              response.data["Filters"]?.TypeFilters?.find((x) => x.FilterName === "DesignType")
                ?.Values || [];
            let tempDesignType = {
              en: [],
              fa: [],
            };
            let promiseArr5 = [];
            if (DesignType.length) {
              DesignType.sort((a, b) => (a["EnTitle"] || "").localeCompare(b["EnTitle"] || ""))
                .filter((obj) => obj["Count"] !== 0)
                .forEach((obj, index) => {
                  promiseArr5[index] = new Promise((resolve, reject) => {
                    tempDesignType["en"][index] = {
                      value: obj["Value"],
                      label: obj["EnTitle"],
                      UrlName: obj["UrlName"],
                    };
                    tempDesignType["fa"][index] = {
                      value: obj["Value"],
                      label: obj["Title"],
                      UrlName: obj["UrlName"],
                    };
                    resolve();
                  });
                });
            }

            let opacity =
              response.data["Filters"]?.TypeFilters?.find((x) => x.FilterName === "Opacity")
                ?.Values || [];
            let tempOpacity = {
              en: [],
              fa: [],
            };
            let promiseArr6 = [];
            if (opacity.length) {
              opacity
                .sort((a, b) => (a["EnTitle"] || "").localeCompare(b["EnTitle"] || ""))
                .filter((obj) => obj["Count"] !== 0)
                .forEach((obj, index) => {
                  promiseArr6[index] = new Promise((resolve, reject) => {
                    tempOpacity["en"][index] = {
                      value: obj["Value"],
                      label: obj["EnTitle"],
                      UrlName: obj["UrlName"],
                      fa_name: obj["Title"],
                    };
                    tempOpacity["fa"][index] = {
                      value: obj["Value"],
                      label: obj["EnTitle"],
                      UrlName: obj["UrlName"],
                      fa_name: obj["Title"],
                    };
                    resolve();
                  });
                });
            }
            let HangingStyle = response.data["Filters"]["SewingModels"] || [];
            let tempHangingStyle = {
              en: [],
              fa: [],
            };
            let promiseArr7 = [];
            if (HangingStyle.length) {
              HangingStyle.sort((a, b) =>
                (a["ModelENName"] || "").localeCompare(b["ModelENName"] || "")
              )
                .filter((obj) => obj["Count"] !== 0)
                .forEach((obj, index) => {
                  promiseArr7[index] = new Promise((resolve, reject) => {
                    tempHangingStyle["en"][index] = {
                      value: obj["SewingModelId"],
                      label: obj["ModelENName"],
                      UrlName: obj["UrlName"],
                    };
                    tempHangingStyle["fa"][index] = {
                      value: obj["SewingModelId"],
                      label: obj["ModelName"],
                      UrlName: obj["UrlName"],
                    };
                    resolve();
                  });
                });
            }

            let ProductSize =
              response.data["Filters"]?.TypeFilters?.find((x) => x.FilterName === "Size")?.Values ||
              [];
            let tempProductSize = {
              en: [],
              fa: [],
            };
            let promiseArr8 = [];
            if (ProductSize.length) {
              ProductSize.sort((a, b) => (a["EnTitle"] || "").localeCompare(b["EnTitle"] || ""))
                .filter((obj) => obj["Count"] !== 0)
                .forEach((obj, index) => {
                  promiseArr8[index] = new Promise((resolve, reject) => {
                    tempProductSize["en"][index] = {
                      value: obj["Value"],
                      label: obj["EnTitle"],
                      UrlName: obj["UrlName"],
                    };
                    tempProductSize["fa"][index] = {
                      value: obj["Value"],
                      label: obj["Title"],
                      UrlName: obj["UrlName"],
                    };
                    resolve();
                  });
                });
            }

            let Material =
              response.data["Filters"]?.TypeFilters?.find((x) => x.FilterName === "Material")
                ?.Values || [];
            let tempMaterial = {
              en: [],
              fa: [],
            };
            let promiseArr9 = [];
            if (Material.length) {
              Material.sort((a, b) => (a["EnTitle"] || "").localeCompare(b["EnTitle"] || ""))
                .filter((obj) => obj["Count"] !== 0)
                .forEach((obj, index) => {
                  promiseArr9[index] = new Promise((resolve, reject) => {
                    tempMaterial["en"][index] = {
                      value: obj["Value"],
                      label: obj["EnTitle"],
                      UrlName: obj["UrlName"],
                    };
                    tempMaterial["fa"][index] = {
                      value: obj["Value"],
                      label: obj["Title"],
                      UrlName: obj["UrlName"],
                    };
                    resolve();
                  });
                });
            }
            let size =
              response.data["Filters"]?.TypeFilters?.find((x) => x.FilterName === "Size")?.Values ||
              [];
            let tempSize = {
              en: [],
              fa: [],
            };
            let promiseArr10 = [];
            if (size.length) {
              size
                .sort((a, b) => (a["EnTitle"] || "").localeCompare(b["EnTitle"] || ""))
                .filter((obj) => obj["Count"] !== 0)
                .forEach((obj, index) => {
                  promiseArr10[index] = new Promise((resolve, reject) => {
                    tempSize["en"][index] = {
                      value: obj["Value"],
                      label: obj["EnTitle"],
                      UrlName: obj["UrlName"],
                    };
                    tempSize["fa"][index] = {
                      value: obj["Value"],
                      label: obj["Title"],
                      UrlName: obj["UrlName"],
                    };
                    resolve();
                  });
                });
            }

            let Lining =
              response.data["Filters"]?.TypeFilters?.find((x) => x.FilterName === "LiningType")
                ?.Values || [];
            let tempLining = {
              en: [],
              fa: [],
            };
            let promiseArrLining = [];
            if (Lining.length) {
              Lining.sort((a, b) => (a["EnTitle"] || "").localeCompare(b["EnTitle"] || ""))
                .filter((obj) => obj["Count"] !== 0)
                .forEach((obj, index) => {
                  promiseArrLining[index] = new Promise((resolve, reject) => {
                    tempLining["en"][index] = {
                      value: obj["ValueName"] || obj["UrlName"],
                      label: obj["EnTitle"],
                      UrlName: obj["UrlName"],
                    };
                    tempLining["fa"][index] = {
                      value: obj["ValueName"] || obj["UrlName"],
                      label: obj["Title"],
                      UrlName: obj["UrlName"],
                    };
                    resolve();
                  });
                });
            }

            let application =
              response.data["Filters"]?.TypeFilters?.find((x) => x.FilterName === "Application")
                ?.Values || [];
            let tempEndUse = {
              en: [],
              fa: [],
            };
            let promiseArr11 = [];
            if (application.length) {
              application
                .sort((a, b) => (a["EnTitle"] || "").localeCompare(b["EnTitle"] || ""))
                .filter((obj) => obj["Count"] !== 0)
                .forEach((obj, index) => {
                  promiseArr11[index] = new Promise((resolve, reject) => {
                    tempEndUse["en"][index] = {
                      value: obj["Value"],
                      label: obj["EnTitle"],
                      UrlName: obj["UrlName"],
                    };
                    tempEndUse["fa"][index] = {
                      value: obj["Value"],
                      label: obj["Title"],
                      UrlName: obj["UrlName"],
                    };
                    resolve();
                  });
                });
            }

            Promise.all([
              ...promiseArr2,
              ...promiseArr3,
              ...promiseArr4,
              ...promiseArr5,
              ...promiseArr6,
              ...promiseArr7,
              ...promiseArr8,
              ...promiseArr9,
              ...promiseArr10,
              ...promiseArrLining,
              ...promiseArr11,
            ]).then(() => {
              if (requestId !== productsRequestIdRef.current) {
                return;
              }
              if (isStaleRoute(requestPathname, requestCatID)) {
                return;
              }
              let filters = {
                Colors: tempColors,
                Patterns: tempDesignPattern,
                Types: tempDesignType,
                Prices: tempPriceLevels,
                opacity: tempOpacity,
                size: tempSize,
                Lining: tempLining,
                hangingStyle: tempHangingStyle,
                ProductSize: tempProductSize,
                Material: tempMaterial,
                application: tempEndUse,
              };

              setProductFilters(filters);
            });
          } else {
            if (isStaleRoute(requestPathname, requestCatID)) {
              return;
            }
            setCatProducts({});
          }
        })
        .catch((err) => {
          if (requestId !== productsRequestIdRef.current) {
            return;
          }
          if (isStaleRoute(requestPathname, requestCatID)) {
            return;
          }
          console.log(err);
          setCatProductsList([<h1>{t("No Products")}</h1>]);
        });
  }

  function ContextAwareToggleFilters({ eventKey, callback, textOnHide, textOnShow }) {
    const { activeEventKey } = useContext(AccordionContext);
    const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));
    const isCurrentEventKey = activeEventKey === eventKey;
    return (
      <>
        <button
          className="product_filter_accordion_btn"
          aria-expanded={`${isCurrentEventKey}`}
          type="button"
          onClick={decoratedOnClick}
        >
          <p className="product_filter_accordion_btn_title 1">
            {isCurrentEventKey ? textOnShow : textOnHide}
          </p>
          <div
            className={
              isCurrentEventKey
                ? "product_filter_accordion_btn_img_minus img-fluid"
                : "product_filter_accordion_btn_img_plus img-fluid"
            }
          ></div>
        </button>
      </>
    );
  }

  function renderProducts() {
    let tempCatProducts = JSON.parse(JSON.stringify(catProducts));

    // When a color filter is active, show cards whose color belongs to the
    // selected parent filter (from ColorParents). Swatches under each card are
    // left untouched so the user can still preview other colors of the design.
    if (filterColors && filterColors.length) {
      const normalizeColor = (value) =>
        (value || "")
          .toString()
          .toLowerCase()
          .trim()
          .replace(/[\s_-]+/g, "");
      const selectedColors = filterColors.map(normalizeColor).filter((n) => n);

      Object.keys(tempCatProducts).forEach((key) => {
        const cardColorId = key.split(":").pop();
        const cardProducts = tempCatProducts[key] || [];
        const representative =
          cardProducts.find((p) => String(p.ColorId) === String(cardColorId)) ||
          cardProducts[0];

        if (!representative) {
          delete tempCatProducts[key];
          return;
        }

        const parentColors = (representative.ColorParents || []).map((c) =>
          normalizeColor(c.ColorParentEnName)
        );
        const ownColor = normalizeColor(representative.ColorEnName);

        const isMatch =
          selectedColors.some((color) => parentColors.includes(color)) ||
          selectedColors.includes(ownColor);

        if (!isMatch) {
          delete tempCatProducts[key];
        }
      });
    }

    const transformedArray = [];
    Object.keys(tempCatProducts).forEach((key) => {
      const products = tempCatProducts[key];
      products.sort((a, b) => a.Price - b.Price);
      products.sort((a, b) => a.DiscountedPrice - b.DiscountedPrice);
      const minPriceObj = products[0];
      const maxPriceObj = products[products.length - 1];

      transformedArray.push({
        key: key,
        minPriceObj: minPriceObj.Price,
        maxPriceObj: maxPriceObj.Price,
        minPriceDisObj: minPriceObj.DiscountedPrice,
        maxPriceDisObj: maxPriceObj.DiscountedPrice,
      });
    });

    let MinSortedArr = transformedArray.slice().sort((a, b) => a.minPriceObj - b.minPriceObj);
    let MaxSortedArr = transformedArray.slice().sort((a, b) => b.maxPriceObj - a.maxPriceObj);

    let sortedProducts = [];
    if (selectedSort === "Price, High to Low") {
      sortedProducts = JSON.parse(JSON.stringify(MaxSortedArr));
    } else if (selectedSort === "Price, Low to High") {
      sortedProducts = JSON.parse(JSON.stringify(MinSortedArr));
    } else {
      sortedProducts = JSON.parse(JSON.stringify(transformedArray));
    }
    let temp = [];
    let promiseArr = [];
    sortedProducts.forEach((sortedProduct, productIndex) => {
        promiseArr[productIndex] = new Promise((resolve) => {
          let sortedProductKey = sortedProduct["key"];
          let productPriceMin = sortedProduct["minPriceObj"];
          let productPriceMax = sortedProduct["maxPriceObj"];
          let productPriceDisMin = sortedProduct["minPriceDisObj"];
          let productPriceDisMax = sortedProduct["maxPriceDisObj"];
          let filteredCatProducts = tempCatProducts[sortedProductKey].filter(
            (value, index, self) => index === self.findIndex((Obj) => Obj.ColorId === value.ColorId)
          );
          let DesignCode = filteredCatProducts[0]["DesignCode"];
          let DesignEnName = CapitalizeAllWords(filteredCatProducts[0]["DesignEnName"]);
          let DesignName = convertToPersian(filteredCatProducts[0]["DesignName"]);
          let SewingModelEnName = CapitalizeAllWords(filteredCatProducts[0]["SewingModelEnName"]);
          let SewingModelName = convertToPersian(filteredCatProducts[0]["SewingModelName"]);
          let IsNew = filteredCatProducts[0]["IsNew"];
          let activeProductId =
            filteredCatProducts.find((obj) => obj.ColorId === sortedProductKey.split(":")[1])
              ?.activeProductId || filteredCatProducts[0]["activeProductId"];
          let activeColorId =
            filteredCatProducts.find((obj) => obj.ColorId === sortedProductKey.split(":")[1])
              ?.ColorId || filteredCatProducts[0]["ColorId"];
          let ProductGroupId = filteredCatProducts[0]["ProductGroupId"];
          let DiscountEnName = filteredCatProducts[0]["DiscountEnName"] || "";
          let DiscountName = convertToPersian(filteredCatProducts[0]["DiscountName"] || "");
          let FreeShipping = filteredCatProducts[0]["FreeShipping"];
          let carouselItems = [];
          let temp3 = [];
          let promiseArr2 = [];

          filteredCatProducts?.forEach((filteredCatProduct, filteredCatProductIndex) => {
            promiseArr2[filteredCatProductIndex] = new Promise((resolve) => {
              let ProductId = filteredCatProduct["ProductId"];
              let ColorId = filteredCatProduct["ColorId"];
              let ColorPhotoPath =
                filteredCatProduct["Photos"].find((obj) => obj.PhotoTypeId === 4709)?.PhotoUrl ||
                "";
              let ColorEnName = CapitalizeAllWords(filteredCatProduct["ColorEnName"]);
              let ColorName = convertToPersian(filteredCatProduct["ColorName"]);

              // TODO: problem is here
              if (isActiveColorProduct(activeColor[sortedProductKey], ProductId)) {
                activeProductId = ProductId;
                activeColorId = ColorId;
                let tempPhotosArr = [
                  filteredCatProduct["Photos"].find((obj) => obj.PhotoTypeId === 4702)?.PhotoUrl,
                ];
                tempPhotosArr.push(
                  ...filteredCatProduct["Photos"]
                    .map(function(object) {
                      if (object["PhotoTypeId"] !== 4702 && object["PhotoTypeId"] !== 4709) {
                        return object["PhotoUrl"];
                      } else {
                        return undefined;
                      }
                    })
                    .filter((n) => n)
                );

                tempPhotosArr.forEach((el, j) => {
                  const defaultImageUrl =
                    "/Content/Images/Product/2018/2018-12-27/61600204/61600204_MainInner.jpg?v=54920";

                  const imageUrl =
                    el !== null && el !== undefined
                      ? imgUrl(el)
                      : imgUrl(defaultImageUrl);

                  const pathname = `/${pageLanguage}/${
                    location.pathname.split("/")[2]
                  }/${catID}/${ProductGroupId}/${DesignCode}`;
                  const search = `Product=${activeProductId}`;

                  carouselItems.push({
                    pathname,
                    search,
                    imageUrl,
                  });
                });
              } else {
                // console.log(
                //   "ProductId",
                //   activeColor[sortedProductKey],
                //   sortedProductKey,
                //   ProductId
                // );
              }

              if (filteredCatProductIndex < maxColors) {
                temp3.push(
                  <li
                    key={"item" + filteredCatProductIndex}
                    className={`Accessories_List_item_colors_list_item ${
                      isActiveColorProduct(activeColor[sortedProductKey], ProductId)
                        ? "colorSelected"
                        : ""
                    }`}
                    onClick={() => {
                      setChangeColor({
                        key: sortedProductKey,
                        id: ProductId,
                        carousel: undefined,
                      });
                    }}
                  >
                    <OverlayContainer
                      classNames="Accessories_List_item_color"
                      placement="middle"
                      children={
                        <div
                          className="Accessories_List_item_colors_list_item_overlay"
                          style={{
                            background: `transparent url(${imgUrl(ColorPhotoPath)}) no-repeat`,
                          }}
                        />
                      }
                      component={
                        <div className="Accessories_List_item_color_container">
                          <p className="Accessories_List_item_color_text">
                            {pageLanguage === "en" ? ColorEnName : ColorName}
                          </p>
                        </div>
                      }
                    />
                  </li>
                );
              } else if (filteredCatProductIndex === maxColors) {
                temp3.push(
                  <li
                    key={"moreItem"}
                    className="Accessories_List_item_colors_list_item moreItem"
                    onClick={() => {
                      console.log("More colors clicked");
                    }}
                  >
                    <div className="Accessories_List_item_color_container">
                      <p className="Accessories_List_More">{t("+ More")}</p>
                    </div>
                  </li>
                );
              }

              resolve();
            });
          });

          Promise.all(promiseArr2).then(() => {
            temp.push(
              <li
                key={"list" + productIndex + activeColorId}
                className={
                  columnCountWidth === 2
                    ? "products_list_item-two"
                    : columnCountWidth === 3 ||
                      columnCountWidth === null ||
                      columnCountWidth === undefined ||
                      columnCountWidth === 0
                    ? "products_list_item"
                    : columnCountWidth === 4
                    ? "products_list_item-four"
                    : columnCountWidth === 5
                    ? "products_list_item-five"
                    : "products_list_item"
                }
              >
                <div className="products_list_item_img">
                  <Carousel variant="dark" interval={null} defaultActiveIndex={0}>
                    {carouselItems?.map((item) => {
                      return (
                        <Carousel.Item key={item.imageUrl} className="unselectable pointer">
                          <Link
                            className="products_list_item_link 6"
                            to={{
                              pathname: item.pathname,
                              search: item.search,
                            }}
                          >
                            <WebPImageTag src={item.imageUrl} alt="" />
                          </Link>
                        </Carousel.Item>
                      );
                    })}
                  </Carousel>
                </div>
                <div className="products_list_item_body">
                  <div className="products_list_item_body_color">
                    <ul className="products_list_item_body_color_list Accessories_List_item_colors_list_item_more">
                      {temp3}
                    </ul>
                  </div>
                  <div className="products_list_item_body_new">
                    <h3>{IsNew ? t("NEW") : ""}</h3>
                  </div>
                  <div className="products_list_item_body_desc">
                    <Link
                      className="products_list_item_link 7"
                      to={{
                        pathname:
                          "/" +
                          pageLanguage +
                          "/" +
                          location.pathname.split("/")[2] +
                          "/" +
                          catID +
                          "/" +
                          +ProductGroupId +
                          "/" +
                          DesignCode,
                        search: `Product=${activeProductId}`,
                      }}
                    >
                      <div className="products_list_item_body_desc_title title_product">
                        <span>
                          {pageLanguage === "en" ? DesignEnName : convertToPersian(DesignName)}{" "}
                          {location.pathname.split("/")[2] !== "Ready-Made-Fabric  "
                            ? pageLanguage === "fa"
                              ? SewingModelName
                              : SewingModelEnName
                            : ""}
                        </span>

                        <span>{ProductGroupId === "10" && t("Fabric By The Meter")}</span>
                      </div>
                    </Link>

                    <div
                      className="products_list_item_body_desc_price_range"
                      style={
                        productPriceMin !== productPriceDisMin
                          ? { textDecoration: "line-through" }
                          : {}
                      }
                    >
                      {productPriceMin === productPriceMax
                        ? GetPrice(
                            productPriceMin,
                            pageLanguage,
                            pageLanguage === "en" ? "Tomans" : "تومان",
                            isTabletOrMobile
                          )
                        : pageLanguage === "fa"
                        ? GetPrice(productPriceMax, pageLanguage, "") +
                          " - " +
                          GetPrice(productPriceMin, pageLanguage, "تومان", isTabletOrMobile)
                        : GetPrice(productPriceMin, pageLanguage, "") +
                          " - " +
                          GetPrice(productPriceMax, pageLanguage, "Tomans", isTabletOrMobile)}
                    </div>

                    {productPriceMin !== productPriceDisMin && (
                      <div className="products_list_item_body_desc_more_desc">
                        {productPriceDisMin === productPriceDisMax
                          ? GetPrice(
                              productPriceDisMin,
                              pageLanguage,
                              pageLanguage === "en" ? "Tomans" : "تومان",
                              isTabletOrMobile
                            )
                          : pageLanguage === "fa"
                          ? GetPrice(productPriceDisMax, pageLanguage, "") +
                            " - " +
                            GetPrice(productPriceDisMin, pageLanguage, "تومان", isTabletOrMobile)
                          : GetPrice(productPriceDisMin, pageLanguage, "") +
                            " - " +
                            GetPrice(productPriceDisMax, pageLanguage, "Tomans", isTabletOrMobile)}
                      </div>
                    )}

                    {DiscountEnName && DiscountEnName !== "" && (
                      <div className="products_list_item_body_desc_more_desc">
                        {pageLanguage === "en" ? DiscountEnName : convertToPersian(DiscountName)}
                      </div>
                    )}
                    {FreeShipping && (
                      <div className="products_list_item_body_desc_more_desc">
                        {t("Free Shipping")}
                      </div>
                    )}
                  </div>
                </div>
              </li>
            );
            resolve();
          });
        });
      });
      Promise.all(promiseArr).then(() => {
        setCatProductsList(temp);
      });
  }

  function filterSelected(filter, filterId, isDelete, UrlName) {
    if (UrlName === undefined || UrlName === null) {
      UrlName = filterId;
    }
    if (UrlName.includes(" ")) {
      UrlName = UrlName.replace(/ /g, "_");
    }

    if (filter === "colors") {
      if (!filterColors.includes(UrlName)) {
        setFilterColors([...filterColors, UrlName]);
      } else {
        setFilterColors(filterColors.filter((id1) => id1 !== UrlName));
      }
    } else if (filter === "patterns") {
      if (!filterPatterns.includes(UrlName)) {
        setFilterPatterns([...filterPatterns, UrlName]);
      } else {
        setFilterPatterns(filterPatterns.filter((id1) => id1 !== UrlName));
      }
    } else if (filter === "type") {
      if (!filterTypes.includes(UrlName)) {
        setFilterTypes([...filterTypes, UrlName]);
      } else {
        setFilterTypes(filterTypes.filter((id1) => id1 !== UrlName));
      }
    } else if (filter === "price") {
      const decodedUrlName = decodeURIComponent(UrlName);
      if (!filterPrices.includes(decodedUrlName)) {
        setFilterPrices([...filterPrices, decodedUrlName]);
      } else {
        setFilterPrices(filterPrices.filter((id1) => id1 !== decodedUrlName));
      }
    } else if (filter === "opacity") {
      if (!filterOpacity.includes(UrlName)) {
        setFilterOpacity([...filterOpacity, UrlName]);
      } else {
        setFilterOpacity(filterOpacity.filter((id1) => id1 !== UrlName));
      }
    } else if (filter === "size") {
      if (!filterSize.includes(UrlName)) {
        setFilterSize([...filterSize, UrlName]);
      } else {
        setFilterSize(filterSize.filter((id1) => id1 !== UrlName));
      }
    } else if (filter === "Lining") {
      if (!filterLiningType.includes(UrlName)) {
        setFilterLiningType([...filterLiningType, UrlName]);
      } else {
        setFilterLiningType(filterLiningType.filter((id1) => id1 !== UrlName));
      }
    } else if (filter === "hangingStyle") {
      if (!filterHangingStyle.includes(UrlName)) {
        setFilterHangingStyle([...filterHangingStyle, UrlName]);
      } else {
        setFilterHangingStyle(filterHangingStyle.filter((id1) => id1 !== UrlName));
      }
    } else if (filter === "ProductSize") {
      if (!filterProductSize.includes(UrlName)) {
        setFilterProductSize([...filterProductSize, UrlName]);
      } else {
        setFilterProductSize(filterProductSize.filter((id1) => id1 !== UrlName));
      }
    } else if (filter === "Material") {
      if (!filterMaterial.includes(UrlName)) {
        setFilterMaterial([...filterMaterial, UrlName]);
      } else {
        setFilterMaterial(filterMaterial.filter((id1) => id1 !== UrlName));
      }
    } else if (filter === "application") {
      if (!filterEndUse.includes(UrlName)) {
        setFilterEndUse([...filterEndUse, UrlName]);
      } else {
        setFilterEndUse(filterEndUse.filter((id1) => id1 !== UrlName));
      }
    }

    let tempFilter = searchParams.get(filter)?.split("-") || [];
    setBaseFilter(filter);
    if (!tempFilter.includes(UrlName)) {
      searchParams.delete(filter);
      searchParams.set(
        filter,
        encodeURIComponent([...tempFilter, UrlName].filter((n) => n).join("-"))
      );
      setSearchParams(searchParams);
    } else {
      let tempArr = tempFilter.filter((id1) => id1 !== UrlName).filter((n) => n) || [];
      if (tempArr.length) {
        searchParams.delete(filter);
        searchParams.set(filter, encodeURIComponent(tempArr.join("-")));
        setSearchParams(searchParams);
      } else {
        searchParams.delete(filter);
        setSearchParams(searchParams);
      }
    }
  }

  function renderSelectedFilters() {
    if (selectedFilters?.length !== 0 && Object.keys(productFilters).length) {
      let temp = [];
      let promiseArr = [];
      filterColors.forEach((id, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          let tempObj =
            productFilters["Colors"]["en"].find((obj) => {
              const formattedLabel = obj.label.replace(/ /g, "_");
              return formattedLabel === id;
            }) || {};
          temp.push(
            <li key={"filter" + id + index + tempObj["label"]} className="filter_container">
              <div title="" className="dropdown">
                <button
                  aria-expanded="false"
                  type="button"
                  className="dropdown_btn dropdown-toggle btn btn-primary"
                >
                  <p>{tempObj["label"] ? t(tempObj["label"]) : t(filterColors[0])}</p>
                  <div
                    className="select_control_delete_filter img-fluid"
                    onClick={() =>
                      setFilterChanged({
                        filter: "colors",
                        filter_id: id,
                        isDelete: false,
                        UrlName: id,
                      })
                    }
                  ></div>
                </button>
              </div>
            </li>
          );
          resolve();
        });
      });
      let promiseArr2 = [];
      filterPatterns.forEach((id, index) => {
        promiseArr2[index] = new Promise((resolve, reject) => {
          let tempObj =
            productFilters["Patterns"]["en"].find((obj) => {
              const formattedLabel = obj.label.replace(/ /g, "_");
              return formattedLabel === id;
            }) || {};

          temp.push(
            <li key={"filter" + id + index + tempObj["label"]} className="filter_container">
              <div title="" className="dropdown">
                <button
                  aria-expanded="false"
                  type="button"
                  className="dropdown_btn dropdown-toggle btn btn-primary"
                >
                  <p>{tempObj["label"] ? t(tempObj["label"]) : t(filterPatterns[0])}</p>
                  <div
                    className="select_control_delete_filter img-fluid"
                    onClick={() =>
                      setFilterChanged({
                        filter: "patterns",
                        filter_id: id,
                        isDelete: false,
                        UrlName: id,
                      })
                    }
                  ></div>
                </button>
              </div>
            </li>
          );
          resolve();
        });
      });
      let promiseArr3 = [];
      filterTypes.forEach((id, index) => {
        promiseArr3[index] = new Promise((resolve, reject) => {
          let tempObj =
            productFilters["Types"]["en"].find((obj) => {
              const formattedLabel = obj.label.replace(/ /g, "_");

              return formattedLabel === id;
            }) || {};
          temp.push(
            <li key={"filter" + id + index + tempObj["label"]} className="filter_container">
              <div title="" className="dropdown">
                <button
                  aria-expanded="false"
                  type="button"
                  className="dropdown_btn dropdown-toggle btn btn-primary"
                >
                  <p>{tempObj["label"] ? t(tempObj["label"]) : t(filterTypes[0])}</p>
                  <div
                    className="select_control_delete_filter img-fluid"
                    onClick={() =>
                      setFilterChanged({
                        filter: "type",
                        filter_id: id,
                        isDelete: false,
                        UrlName: id,
                      })
                    }
                  ></div>
                </button>
              </div>
            </li>
          );
          resolve();
        });
      });
      let promiseArr4 = [];
      filterPrices.forEach((id, index) => {
        promiseArr4[index] = new Promise((resolve, reject) => {
          let tempObj =
            productFilters["Prices"]["en"].find((obj) => {
              const formattedLabel = obj.label.replace(/ /g, "_");
              return formattedLabel === id;
            }) || {};
          let priceLabel = tempObj["label"];
          if (pageLanguage === "fa" && tempObj["UrlName"]) {
            const faPriceObj =
              productFilters["Prices"]["fa"]?.find((obj) => obj.UrlName === tempObj["UrlName"]) ||
              {};
            priceLabel = faPriceObj["label"] || priceLabel;
          }
          const priceFilterText = priceLabel
            ? /\d/.test(priceLabel)
              ? convertToPersian(formatPrice(priceLabel), pageLanguage)
              : convertToPersian(capitalizeFirstLetters(priceLabel), pageLanguage)
            : t(filterPrices[0]);
          temp.push(
            <li key={"filter" + id + index + tempObj["label"]} className="filter_container">
              <div title="" className="dropdown">
                <button
                  aria-expanded="false"
                  type="button"
                  className="dropdown_btn dropdown-toggle btn btn-primary"
                >
                  <p>{priceFilterText}</p>
                  <div
                    className="select_control_delete_filter img-fluid"
                    onClick={() =>
                      setFilterChanged({
                        filter: "price",
                        filter_id: id,
                        isDelete: false,
                        UrlName: id,
                      })
                    }
                  ></div>
                </button>
              </div>
            </li>
          );
          resolve();
        });
      });
      let promiseArr5 = [];
      filterOpacity.forEach((id, index) => {
        promiseArr5[index] = new Promise((resolve, reject) => {
          let tempObj =
            productFilters["opacity"]["en"].find((obj) => {
              const formattedLabel = obj.label.replace(/ /g, "_");
              return formattedLabel === id;
            }) || {};
          temp.push(
            <li key={"filter" + id + index + tempObj["label"]} className="filter_container">
              <div title="" className="dropdown">
                <button
                  aria-expanded="false"
                  type="button"
                  className="dropdown_btn dropdown-toggle btn btn-primary"
                >
                  <p>{tempObj["label"] ? t(tempObj["label"]) : t(filterOpacity[0])}</p>
                  <div
                    className="select_control_delete_filter img-fluid"
                    onClick={() =>
                      setFilterChanged({
                        filter: "opacity",
                        filter_id: id,
                        isDelete: false,
                        UrlName: id,
                      })
                    }
                  ></div>
                </button>
              </div>
            </li>
          );
          resolve();
        });
      });

      let promiseArr6 = [];
      filterHangingStyle.forEach((id, index) => {
        promiseArr6[index] = new Promise((resolve, reject) => {
          let tempObj =
            productFilters["hangingStyle"]["en"].find((obj) => {
              const formattedLabel = obj.label.replace(/ /g, "_");
              return formattedLabel === id;
            }) || {};
          temp.push(
            <li key={"filter" + id + index + tempObj["label"]} className="filter_container">
              <div title="" className="dropdown">
                <button
                  aria-expanded="false"
                  type="button"
                  className="dropdown_btn dropdown-toggle btn btn-primary"
                >
                  <p>{tempObj["label"] ? t(tempObj["label"]) : t(filterHangingStyle[0])}</p>
                  <div
                    className="select_control_delete_filter img-fluid"
                    onClick={() =>
                      setFilterChanged({
                        filter: "hangingStyle",
                        filter_id: id,
                        isDelete: false,
                        UrlName: id,
                      })
                    }
                  ></div>
                </button>
              </div>
            </li>
          );
          resolve();
        });
      });

      let promiseArr7 = [];
      filterProductSize.forEach((id, index) => {
        promiseArr7[index] = new Promise((resolve, reject) => {
          let tempObj =
            productFilters["ProductSize"]["en"].find((obj) => {
              const formattedLabel = obj.label.replace(/ /g, "_");
              return formattedLabel === id;
            }) || {};
          temp.push(
            <li key={"filter" + id + index + tempObj["label"]} className="filter_container">
              <div title="" className="dropdown">
                <button
                  aria-expanded="false"
                  type="button"
                  className="dropdown_btn dropdown-toggle btn btn-primary"
                >
                  <p>{tempObj["label"] ? t(tempObj["label"]) : t(filterProductSize[0])}</p>
                  <div
                    className="select_control_delete_filter img-fluid"
                    onClick={() =>
                      setFilterChanged({
                        filter: "ProductSize",
                        filter_id: id,
                        isDelete: false,
                        UrlName: id,
                      })
                    }
                  ></div>
                </button>
              </div>
            </li>
          );
          resolve();
        });
      });

      let promiseArr8 = [];
      filterMaterial.forEach((id, index) => {
        promiseArr8[index] = new Promise((resolve, reject) => {
          let tempObj =
            productFilters["Material"][pageLanguage].find((obj) => {
              const formattedLabel = obj.label.replace(/ /g, "_");
              return formattedLabel === id;
            }) || {};
          temp.push(
            <li key={"filter" + id + index + tempObj["label"]} className="filter_container">
              <div title="" className="dropdown">
                <button
                  aria-expanded="false"
                  type="button"
                  className="dropdown_btn dropdown-toggle btn btn-primary"
                >
                  <p>{tempObj["label"] ? t(tempObj["label"]) : t(filterMaterial[0])}</p>
                  <div
                    className="select_control_delete_filter img-fluid"
                    onClick={() =>
                      setFilterChanged({
                        filter: "Material",
                        filter_id: id,
                        isDelete: false,
                        UrlName: id,
                      })
                    }
                  ></div>
                </button>
              </div>
            </li>
          );
          resolve();
        });
      });
      let promiseArr9 = [];
      filterSize.forEach((id, index) => {
        promiseArr9[index] = new Promise((resolve, reject) => {
          let tempObj =
            productFilters["size"]["en"].find((obj) => {
              const formattedLabel = obj.label.replace(/ /g, "_");
              return formattedLabel === id;
            }) || {};
          temp.push(
            <li key={"filter" + id + index} className="filter_container">
              <div title="" className="dropdown">
                <button
                  aria-expanded="false"
                  type="button"
                  className="dropdown_btn dropdown-toggle btn btn-primary"
                >
                  <p>{t(tempObj["label"])}</p>
                  <div
                    className="select_control_delete_filter img-fluid"
                    onClick={() =>
                      setFilterChanged({
                        filter: "size",
                        filter_id: id,
                        isDelete: false,
                        UrlName: id,
                      })
                    }
                  ></div>
                </button>
              </div>
            </li>
          );
          resolve();
        });
      });

      let promiseArrLining = [];
      filterLiningType.forEach((id, index) => {
        promiseArrLining[index] = new Promise((resolve, reject) => {
          let tempObj =
            productFilters["Lining"]["en"].find((obj) => {
              const formattedLabel = obj.label.replace(/ /g, "_");
              return formattedLabel === id;
            }) || {};
          temp.push(
            <li key={"filter" + id + index} className="filter_container">
              <div title="" className="dropdown">
                <button
                  aria-expanded="false"
                  type="button"
                  className="dropdown_btn dropdown-toggle btn btn-primary"
                >
                  <p>{t(tempObj["label"])}</p>
                  <div
                    className="select_control_delete_filter img-fluid"
                    onClick={() =>
                      setFilterChanged({
                        filter: "Lining",
                        filter_id: id,
                        isDelete: false,
                        UrlName: id,
                      })
                    }
                  ></div>
                </button>
              </div>
            </li>
          );
          resolve();
        });
      });

      let promiseArr10 = [];
      filterEndUse.forEach((id, index) => {
        promiseArr10[index] = new Promise((resolve, reject) => {
          let tempObj =
            productFilters["application"]["en"].find((obj) => {
              const formattedLabel = obj.label.replace(/ /g, "_");
              return formattedLabel === id;
            }) || {};

          temp.push(
            <li key={"filter" + id + index} className="filter_container">
              <div title="" className="dropdown">
                <button
                  aria-expanded="false"
                  type="button"
                  className="dropdown_btn dropdown-toggle btn btn-primary"
                >
                  <p>
                    {/* {t(tempObj["label"])} */}
                    {tempObj["label"] ? t(tempObj["label"]) : t(filterEndUse[0])}
                  </p>
                  <div
                    className="select_control_delete_filter img-fluid"
                    onClick={() =>
                      setFilterChanged({
                        filter: "application",
                        filter_id: id,
                        isDelete: false,
                        UrlName: id,
                      })
                    }
                  ></div>
                </button>
              </div>
            </li>
          );
          resolve();
        });
      });
      Promise.all([
        ...promiseArr,
        ...promiseArr2,
        ...promiseArr3,
        ...promiseArr4,
        ...promiseArr5,
        ...promiseArr6,
        ...promiseArr7,
        ...promiseArr8,
        ...promiseArr9,
        ...promiseArrLining,
        ...promiseArr10,
      ]).then(() => {
        if (temp.length) {
          temp.push(
            <li key={"filter_clear"} className="filter_container filter_container_clear_all">
              <div title="" className="dropdown">
                <button
                  aria-expanded="false"
                  type="button"
                  className="dropdown_btn dropdown-toggle btn btn-primary"
                  onClick={() => setClearFilter("All")}
                >
                  <p className="text_underline">{t("Clear All")}</p>
                </button>
              </div>
            </li>
          );

          setSelectedFiltersList(temp);
        } else {
          setSelectedFiltersList([]);
        }
      });
    } else {
      setSelectedFiltersList([]);
    }
  }

  function clearFilters(target) {
    if (target === "colors") {
      setFilterColors([]);
    } else if (target === "patterns") {
      setFilterPatterns([]);
    } else if (target === "type") {
      setFilterTypes([]);
    } else if (target === "price") {
      setFilterPrices([]);
    } else if (target === "opacity") {
      setFilterOpacity([]);
    } else if (target === "size") {
      setFilterSize([]);
    } else if (target === "Lining") {
      setFilterLiningType([]);
    } else if (target === "ProductSize") {
      setFilterProductSize([]);
    } else if (target === "hangingStyle") {
      setFilterHangingStyle([]);
    } else if (target === "Material") {
      setFilterMaterial([]);
    } else if (target === "application") {
      setFilterEndUse([]);
    } else {
      setFilterColors([]);
      setFilterPatterns([]);
      setFilterTypes([]);
      setFilterPrices([]);
      setFilterOpacity([]);
      setFilterSize([]);
      setFilterLiningType([]);
      setFilterProductSize([]);
      setFilterHangingStyle([]);
      setFilterMaterial([]);
      setFilterEndUse([]);
      setSearchParams("");
      setSelectedFilters([]);
      setBaseFilter(undefined);
      if (catObject["Link"]) {
        getCatProducts([]);
      }
    }
  }

  useEffect(() => {
    if (filterChanged["filter"] !== "") {
      setFilterChangedBool(true);
      filterSelected(
        filterChanged["filter"],
        filterChanged["filter_id"].toString(),
        filterChanged["isDelete"],
        filterChanged["UrlName"]
      );

      setFilterChanged({
        filter: "",
        filter_id: undefined,
        isDelete: false,
        UrlName: "",
      });
    }
  }, [filterChanged]);

  useEffect(() => {
    if (pageLanguage !== "") {
      renderSelectedFilters();
    }
  }, [selectedFilters, productFilters, pageLanguage]);

  useEffect(() => {
    if (clearFilter !== undefined) {
      setFilterChangedBool(true);
      clearFilters("All");
      setClearFilter(undefined);
    }
  }, [clearFilter]);

  useEffect(() => {
    if (Object.keys(productFilters).length) {
      filterCheckboxes.current.colors2 = [];
      filterCheckboxes.current.patterns2 = [];
      filterCheckboxes.current.types2 = [];
      filterCheckboxes.current.prices2 = [];
      filterCheckboxes.current.Opacity2 = [];
      filterCheckboxes.current.size2 = [];
      filterCheckboxes.current.LiningType2 = [];
      filterCheckboxes.current.HangingStyle2 = [];
      filterCheckboxes.current.ProductSize2 = [];
      filterCheckboxes.current.Material2 = [];
      filterCheckboxes.current.endUse2 = [];

      if (productFilters["Colors"] && Object.keys(productFilters["Colors"]).length) {
        let promiseArr = [];
        let temp = [];
        productFilters["Colors"][pageLanguage].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            if (index < 5 || showMoreFilter["colors"]) {
              const labelWithUnderscore = obj.UrlName.replace(/ /g, "_");
              temp.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterColors.includes(labelWithUnderscore)}
                      ref={(ref) =>
                        (filterCheckboxes.current["colors2"] = [
                          ...filterCheckboxes.current["colors2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "colors",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                          UrlName: obj["UrlName"],
                        });
                      }}
                      id={"dropdown_color2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_color2" + obj.value + index}
                      className={
                        filterColors.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {pageLanguage === "en" ? capitalizeFirstLetters(obj.label) : obj["fa_name"]}
                  </label>
                </button>
              );
              if (
                productFilters["Colors"][pageLanguage].length > 5 &&
                index === productFilters["Colors"][pageLanguage].length - 1
              ) {
                temp.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("colors")}
                    >
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              temp.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterColors.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["colors2"] = [
                          ...filterCheckboxes.current["colors2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "colors",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_color2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_color2" + obj.value + index}
                      className={
                        filterColors.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(capitalizeFirstLetters(obj.label), pageLanguage)}
                  </label>
                </button>
              );
              if (index === productFilters["Colors"][pageLanguage].length - 1) {
                temp.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("colors")}
                    >
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
        Promise.all(promiseArr).then(() => {
          setSewingColors2(temp);
        });
      }
      if (productFilters["Patterns"] && Object.keys(productFilters["Patterns"]).length) {
        let promiseArr = [];
        let temp = [];
        productFilters["Patterns"][pageLanguage].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            if (index < 5 || showMoreFilter["patterns"]) {
              const labelWithUnderscore = obj.UrlName.replace(/ /g, "_");
              temp.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterPatterns.includes(labelWithUnderscore)}
                      ref={(ref) =>
                        (filterCheckboxes.current["patterns2"] = [
                          ...filterCheckboxes.current["patterns2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "patterns",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                          UrlName: obj["UrlName"],
                        });
                      }}
                      id={"dropdown_pattern2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_pattern2" + obj.value + index}
                      className={
                        filterPatterns.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(capitalizeFirstLetters(obj.label), pageLanguage)}
                  </label>
                </button>
              );
              if (
                productFilters["Patterns"][pageLanguage].length > 5 &&
                index === productFilters["Patterns"][pageLanguage].length - 1
              ) {
                temp.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("patterns")}
                    >
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              temp.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterPatterns.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["patterns2"] = [
                          ...filterCheckboxes.current["patterns2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "patterns",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_pattern2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_pattern2" + obj.value + index}
                      className={
                        filterPatterns.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(capitalizeFirstLetters(obj.label), pageLanguage)}
                  </label>
                </button>
              );
              if (index === productFilters["Patterns"][pageLanguage].length - 1) {
                temp.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("patterns")}
                    >
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
        Promise.all(promiseArr).then(() => {
          setSewingPatterns2(temp);
        });
      }
      if (productFilters["Types"] && Object.keys(productFilters["Types"]).length) {
        let promiseArr = [];
        let temp = [];
        productFilters["Types"][pageLanguage].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            if (index < 5 || showMoreFilter["type"]) {
              const labelWithUnderscore = obj.UrlName.replace(/ /g, "_");
              temp.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterTypes.includes(labelWithUnderscore)}
                      ref={(ref) =>
                        (filterCheckboxes.current["types2"] = [
                          ...filterCheckboxes.current["types2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "type",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                          UrlName: obj["UrlName"],
                        });
                      }}
                      id={"dropdown_types2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_types2" + obj.value + index}
                      className={
                        filterTypes.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(capitalizeFirstLetters(obj.label), pageLanguage)}
                  </label>
                </button>
              );
              if (
                productFilters["Types"][pageLanguage].length > 5 &&
                index === productFilters["Types"][pageLanguage].length - 1
              ) {
                temp.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p className="text_underline" onClick={() => setShowMoreFilterTrigger("type")}>
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              temp.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterTypes.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["types2"] = [
                          ...filterCheckboxes.current["types2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "type",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_types2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_types2" + obj.value + index}
                      className={
                        filterTypes.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(capitalizeFirstLetters(obj.label), pageLanguage)}
                  </label>
                </button>
              );
              if (index === productFilters["Types"][pageLanguage].length - 1) {
                temp.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p className="text_underline" onClick={() => setShowMoreFilterTrigger("type")}>
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
        Promise.all(promiseArr).then(() => {
          setSewingTypes2(temp);
        });
      }
      if (productFilters["Prices"] && Object.keys(productFilters["Prices"]).length) {
        let promiseArr = [];
        let temp = [];
        productFilters["Prices"][pageLanguage]
          .slice()
          .reverse()
          .forEach((obj, index) => {
            promiseArr[index] = new Promise((resolve, reject) => {
              if (index < 5 || showMoreFilter["price"]) {
                const labelWithUnderscore = obj?.UrlName?.replace(/ /g, "_");
                temp.push(
                  <button key={index} className="dropdown-item btn btn-primary">
                    <label className="dropdown_label">
                      <input
                        type="checkbox"
                        filter-id={obj.value}
                        checked={filterPrices.includes(labelWithUnderscore)}
                        ref={(ref) =>
                          (filterCheckboxes.current["prices2"] = [
                            ...filterCheckboxes.current["prices2"],
                            ref,
                          ])
                        }
                        onChange={(e) => {
                          setFilterChanged({
                            filter: "price",
                            filter_id: e.target.getAttribute("filter-id"),
                            isDelete: e.target.checked,
                            UrlName: obj["UrlName"],
                          });
                        }}
                        id={"dropdown_price2" + obj.value + index}
                      />
                      <label
                        htmlFor={"dropdown_price2" + obj.value + index}
                        className={
                          filterPrices.includes(obj.value.toString())
                            ? "checkbox_label checked"
                            : "checkbox_label"
                        }
                      >
                        <img
                          className="checkbox_label_img checkmark1 img-fluid"
                          src={require("../Images/public/checkmark1_checkbox.png")}
                          alt=""
                        />
                      </label>

                      {/\d/.test(obj.label) ? (
                        <>{convertToPersian(formatPrice(obj.label), pageLanguage)}</>
                      ) : (
                        <>{convertToPersian(capitalizeFirstLetters(obj.label), pageLanguage)}</>
                      )}
                    </label>
                  </button>
                );
                if (
                  productFilters["Prices"][pageLanguage].length > 5 &&
                  index === productFilters["Prices"][pageLanguage].length - 1
                ) {
                  temp.push(
                    <button
                      key={index + "show_more"}
                      className="dropdown-item btn btn-primary show_more_filters"
                    >
                      <p
                        className="text_underline"
                        onClick={() => setShowMoreFilterTrigger("price")}
                      >
                        {t("Show Less")}
                      </p>
                    </button>
                  );
                }
                resolve();
              } else {
                temp.push(
                  <button key={index} className="dropdown-item btn btn-primary hidden">
                    <label className="dropdown_label">
                      <input
                        type="checkbox"
                        filter-id={obj.value}
                        checked={filterPrices.includes(obj.value.toString())}
                        ref={(ref) =>
                          (filterCheckboxes.current["prices2"] = [
                            ...filterCheckboxes.current["prices2"],
                            ref,
                          ])
                        }
                        onChange={(e) => {
                          setFilterChanged({
                            filter: "price",
                            filter_id: e.target.getAttribute("filter-id"),
                            isDelete: e.target.checked,
                          });
                        }}
                        id={"dropdown_price2" + obj.value + index}
                      />
                      <label
                        htmlFor={"dropdown_price2" + obj.value + index}
                        className={
                          filterPrices.includes(obj.value.toString())
                            ? "checkbox_label checked"
                            : "checkbox_label"
                        }
                      >
                        <img
                          className="checkbox_label_img checkmark1 img-fluid"
                          src={require("../Images/public/checkmark1_checkbox.png")}
                          alt=""
                        />
                      </label>
                      {/\d/.test(obj.label) ? (
                        <>{convertToPersian(formatPrice(obj.label), pageLanguage)}</>
                      ) : (
                        <>{convertToPersian(capitalizeFirstLetters(obj.label), pageLanguage)}</>
                      )}
                    </label>
                  </button>
                );
                if (index === productFilters["Prices"][pageLanguage].length - 1) {
                  temp.push(
                    <button
                      key={index + "show_more"}
                      className="dropdown-item btn btn-primary show_more_filters"
                    >
                      <p
                        className="text_underline"
                        onClick={() => setShowMoreFilterTrigger("price")}
                      >
                        {t("Show More")}
                      </p>
                    </button>
                  );
                }
                resolve();
              }
            });
          });
        Promise.all(promiseArr).then(() => {
          setSewingPrices2(temp);
        });
      }
      if (productFilters["opacity"] && Object.keys(productFilters["opacity"]).length) {
        let promiseArr = [];
        let temp = [];
        productFilters["opacity"][pageLanguage].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            if (index < 5 || showMoreFilter["opacity"]) {
              const labelWithUnderscore = obj.UrlName.replace(/ /g, "_");
              temp.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterOpacity.includes(labelWithUnderscore)}
                      ref={(ref) =>
                        (filterCheckboxes.current["Opacity2"] = [
                          ...filterCheckboxes.current["Opacity2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "opacity",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                          UrlName: obj["UrlName"],
                        });
                      }}
                      id={"dropdown_Opacity2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_Opacity2" + obj.value + index}
                      className={
                        filterOpacity.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {pageLanguage === "en" ? capitalizeFirstLetters(obj.label) : obj["fa_name"]}
                  </label>
                </button>
              );
              if (
                productFilters["opacity"][pageLanguage].length > 5 &&
                index === productFilters["opacity"][pageLanguage].length - 1
              ) {
                temp.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("opacity")}
                    >
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              temp.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterOpacity.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["Opacity2"] = [
                          ...filterCheckboxes.current["Opacity2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "opacity",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_Opacity2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_Opacity2" + obj.value + index}
                      className={
                        filterOpacity.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(capitalizeFirstLetters(obj.label), pageLanguage)}
                  </label>
                </button>
              );
              if (index === productFilters["opacity"][pageLanguage].length - 1) {
                temp.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("opacity")}
                    >
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
        Promise.all(promiseArr).then(() => {
          setSewingOpacity2(temp);
        });
      }
      if (productFilters["size"] && Object.keys(productFilters["size"]).length) {
        let promiseArr = [];
        let temp = [];
        productFilters["size"][pageLanguage].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            if (index < 5 || showMoreFilter["size"]) {
              const labelWithUnderscore = obj?.UrlName?.replace(/ /g, "_");
              temp.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterSize.includes(labelWithUnderscore)}
                      ref={(ref) =>
                        (filterCheckboxes.current["size2"] = [
                          ...filterCheckboxes.current["size2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "size",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                          UrlName: obj["UrlName"],
                        });
                      }}
                      id={"dropdown_Opacity2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_Opacity2" + obj.value + index}
                      className={
                        filterSize.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(capitalizeFirstLetters(obj.label), pageLanguage)}
                  </label>
                </button>
              );
              if (
                productFilters["size"][pageLanguage].length > 5 &&
                index === productFilters["size"][pageLanguage].length - 1
              ) {
                temp.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p className="text_underline" onClick={() => setShowMoreFilterTrigger("size")}>
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              temp.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterSize.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["size2"] = [
                          ...filterCheckboxes.current["size2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "size",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                          UrlName: obj["UrlName"],
                        });
                      }}
                      id={"dropdown_Opacity2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_Opacity2" + obj.value + index}
                      className={
                        filterOpacity.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(capitalizeFirstLetters(obj.label), pageLanguage)}
                  </label>
                </button>
              );
              if (index === productFilters["size"][pageLanguage].length - 1) {
                temp.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p className="text_underline" onClick={() => setShowMoreFilterTrigger("size")}>
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
        Promise.all(promiseArr).then(() => {
          setSewingSize2(temp);
        });
      }
      if (productFilters["Lining"] && Object.keys(productFilters["Lining"]).length) {
        let promiseArr = [];
        let temp = [];
        productFilters["Lining"][pageLanguage].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            const labelWithUnderscore = obj?.UrlName?.replace(/ /g, "_");
            if (index < 5 || showMoreFilter["Lining"]) {
              temp.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterLiningType.includes(labelWithUnderscore)}
                      ref={(ref) =>
                        (filterCheckboxes.current["LiningType2"] = [
                          ...filterCheckboxes.current["LiningType2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "Lining",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                          UrlName: obj["UrlName"],
                        });
                      }}
                      id={"dropdown_LiningType2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_LiningType2" + obj.value + index}
                      className={
                        filterLiningType.includes(labelWithUnderscore)
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(capitalizeFirstLetters(obj.label), pageLanguage)}
                  </label>
                </button>
              );
              if (
                productFilters["Lining"][pageLanguage].length > 5 &&
                index === productFilters["Lining"][pageLanguage].length - 1
              ) {
                temp.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("Lining")}
                    >
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              temp.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterLiningType.includes(labelWithUnderscore)}
                      ref={(ref) =>
                        (filterCheckboxes.current["LiningType2"] = [
                          ...filterCheckboxes.current["LiningType2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "Lining",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                          UrlName: obj["UrlName"],
                        });
                      }}
                      id={"dropdown_LiningType2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_LiningType2" + obj.value + index}
                      className={
                        filterLiningType.includes(labelWithUnderscore)
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(capitalizeFirstLetters(obj.label), pageLanguage)}
                  </label>
                </button>
              );
              if (index === productFilters["Lining"][pageLanguage].length - 1) {
                temp.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("Lining")}
                    >
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
        Promise.all(promiseArr).then(() => {
          setSewingLiningType(temp);
        });
      }
      if (productFilters["hangingStyle"] && Object.keys(productFilters["hangingStyle"]).length) {
        const hangingStyleItems = productFilters["hangingStyle"][pageLanguage];
        const showAllHangingStyle = showMoreFilter["hangingStyle"];
        let temp = [];

        hangingStyleItems.forEach((obj, index) => {
          const isVisible = index < 5 || showAllHangingStyle;
          const labelWithUnderscore = obj.UrlName.replace(/ /g, "_");
          temp.push(
            <button
              key={index}
              className={`dropdown-item btn btn-primary${isVisible ? "" : " hidden"}`}
            >
              <label className="dropdown_label">
                <input
                  type="checkbox"
                  filter-id={obj.value}
                  checked={filterHangingStyle.includes(labelWithUnderscore)}
                  ref={(ref) =>
                    (filterCheckboxes.current["HangingStyle2"] = [
                      ...filterCheckboxes.current["HangingStyle2"],
                      ref,
                    ])
                  }
                  onChange={(e) => {
                    setFilterChanged({
                      filter: "hangingStyle",
                      filter_id: e.target.getAttribute("filter-id"),
                      isDelete: e.target.checked,
                      UrlName: obj["UrlName"],
                    });
                  }}
                  id={"dropdown_HangingStyle2" + obj.value + index}
                />
                <label
                  htmlFor={"dropdown_HangingStyle2" + obj.value + index}
                  className={
                    filterHangingStyle.includes(labelWithUnderscore)
                      ? "checkbox_label checked"
                      : "checkbox_label"
                  }
                >
                  <img
                    className="checkbox_label_img checkmark1 img-fluid"
                    src={require("../Images/public/checkmark1_checkbox.png")}
                    alt=""
                  />
                </label>
                {convertToPersian(capitalizeFirstLetters(obj.label), pageLanguage)}
              </label>
            </button>
          );
        });

        if (hangingStyleItems.length > 5) {
          temp.push(
            <button
              key="hangingStyle_show_more"
              className="dropdown-item btn btn-primary show_more_filters"
            >
              <p
                className="text_underline"
                onClick={() => setShowMoreFilterTrigger("hangingStyle")}
              >
                {t(showAllHangingStyle ? "Show Less" : "Show More")}
              </p>
            </button>
          );
        }

        setSewingHangingStyle2(temp);
      }
      if (productFilters["Material"] && Object.keys(productFilters["Material"]).length) {
        let promiseArr = [];
        let temp = [];
        productFilters["Material"][pageLanguage].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            const labelWithUnderscore = obj.UrlName.replace(/ /g, "_");
            if (index < 5 || showMoreFilter["Material"]) {
              temp.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterMaterial.includes(labelWithUnderscore)}
                      ref={(ref) =>
                        (filterCheckboxes.current["Material2"] = [
                          ...filterCheckboxes.current["Material2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "Material",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                          UrlName: obj["UrlName"],
                        });
                      }}
                      id={"dropdown_Material2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_Material2" + obj.value + index}
                      className={
                        filterMaterial.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(capitalizeFirstLetters(obj.label), pageLanguage)}
                  </label>
                </button>
              );
              if (
                productFilters["Material"][pageLanguage].length > 5 &&
                index === productFilters["Material"][pageLanguage].length - 1
              ) {
                temp.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("Material")}
                    >
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              temp.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterMaterial.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["Material2"] = [
                          ...filterCheckboxes.current["Material2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "Material",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_Material2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_Material2" + obj.value + index}
                      className={
                        filterMaterial.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(capitalizeFirstLetters(obj.label), pageLanguage)}
                  </label>
                </button>
              );
              if (index === productFilters["Material"][pageLanguage].length - 1) {
                temp.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("Material")}
                    >
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
      }
      if (productFilters["ProductSize"] && Object.keys(productFilters["ProductSize"]).length) {
        let promiseArr = [];
        let temp = [];
        productFilters["ProductSize"][pageLanguage].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            const labelWithUnderscore = obj.UrlName.replace(/ /g, "_");
            if (index < 5 || showMoreFilter["ProductSize"]) {
              temp.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterProductSize.includes(labelWithUnderscore)}
                      ref={(ref) =>
                        (filterCheckboxes.current["ProductSize2"] = [
                          ...filterCheckboxes.current["ProductSize2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "ProductSize",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                          UrlName: obj["UrlName"],
                        });
                      }}
                      id={"dropdown_ProductSize2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_ProductSize2" + obj.value + index}
                      className={
                        filterProductSize.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(capitalizeFirstLetters(obj.label), pageLanguage)}
                  </label>
                </button>
              );
              if (
                productFilters["ProductSize"][pageLanguage].length > 5 &&
                index === productFilters["ProductSize"][pageLanguage].length - 1
              ) {
                temp.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("ProductSize")}
                    >
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              temp.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterProductSize.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["ProductSize2"] = [
                          ...filterCheckboxes.current["ProductSize2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "ProductSize",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_ProductSize2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_ProductSize2" + obj.value + index}
                      className={
                        filterProductSize.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(capitalizeFirstLetters(obj.label), pageLanguage)}
                  </label>
                </button>
              );
              if (index === productFilters["ProductSize"][pageLanguage].length - 1) {
                temp.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("ProductSize")}
                    >
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
      }

      if (productFilters["application"] && Object.keys(productFilters["application"]).length) {
        let promiseArr = [];
        let temp = [];

        productFilters["application"][pageLanguage].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            const labelWithUnderscore = obj.UrlName.replace(/ /g, "_");
            if (index < 5 || showMoreFilter["application"]) {
              temp.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterEndUse.includes(labelWithUnderscore)}
                      ref={(ref) =>
                        (filterCheckboxes.current["endUse2"] = [
                          ...filterCheckboxes.current["endUse2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "application",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                          UrlName: obj["UrlName"],
                        });
                      }}
                      id={"dropdown_Material2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_Material2" + obj.value + index}
                      className={
                        filterEndUse.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(capitalizeFirstLetters(obj.label), pageLanguage)}
                  </label>
                </button>
              );
              if (
                productFilters["application"][pageLanguage].length > 5 &&
                index === productFilters["application"][pageLanguage].length - 1
              ) {
                temp.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("application")}
                    >
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              temp.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterEndUse.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["endUse2"] = [
                          ...filterCheckboxes.current["endUse2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "application",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_Material2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_Material2" + obj.value + index}
                      className={
                        filterEndUse.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>

                    {convertToPersian(capitalizeFirstLetters(obj.label), pageLanguage)}
                  </label>
                </button>
              );
              if (index === productFilters["application"][pageLanguage].length - 1) {
                temp.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("application")}
                    >
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
        Promise.all(promiseArr).then(() => {
          setSewingEndUse2(temp);
        });
      }
    }
  }, [
    productFilters,
    showMoreFilter,
    filterColors,
    filterPatterns,
    filterTypes,
    filterPrices,
    filterOpacity,
    filterHangingStyle,
    filterMaterial,
    filterProductSize,
    filterSize,
    filterLiningType,
    filterEndUse,
    pageLanguage,
  ]);

  useEffect(() => {
    if (showMoreFilterTrigger !== undefined) {
      let temp = JSON.parse(JSON.stringify(showMoreFilter));
      temp[showMoreFilterTrigger] = !temp[showMoreFilterTrigger];
      setShowMoreFilter(temp);
      setShowMoreFilterTrigger(undefined);
    }
  }, [showMoreFilterTrigger]);

  useEffect(() => {
    if (catObject["Link"] !== undefined) {
      let queryObj = {
        colors: searchParams.get("colors")?.split("-") || [],
        patterns: searchParams.get("patterns")?.split("-") || [],
        type: searchParams.get("type")?.split("-") || [],
        price: searchParams.get("price")?.split("-") || [],
        opacity: searchParams.get("opacity")?.split("-") || [],
        size: searchParams.get("size")?.split("-") || [],
        Lining: searchParams.get("Lining")?.split("-") || [],
        ProductSize: searchParams.get("ProductSize")?.split("-") || [],
        hangingStyle: searchParams.get("hangingStyle")?.split("-") || [],
        application: searchParams.get("application")?.split("-") || [],
      };

      if (
        !Object.keys(queryObj).every((key) => queryObj[key].length === 0) ||
        (firstRender.current === false && filterChangedBool)
      ) {
        firstRender.current = false;
        setFilterColors(queryObj["colors"].filter((n) => n));
        setFilterPatterns(queryObj["patterns"].filter((n) => n));
        setFilterTypes(queryObj["type"].filter((n) => n));
        setFilterPrices(queryObj["price"].map(decodeURIComponent).filter((n) => n));
        setFilterOpacity(queryObj["opacity"].filter((n) => n));
        setFilterSize(queryObj["size"].filter((n) => n));
        setFilterLiningType(queryObj["Lining"].filter((n) => n));
        setFilterProductSize(queryObj["ProductSize"].filter((n) => n));
        setFilterHangingStyle(queryObj["hangingStyle"].filter((n) => n));
        setFilterEndUse(queryObj["application"].filter((n) => n));

        if (baseFilter === undefined) {
          setBaseFilter(
            location.search
              ?.split("?")[1]
              ?.split("&")
              ?.pop()
              ?.split("=")[0]
          );
        }

        const tempArr = buildSelectedFiltersArray(queryObj);
        setSelectedFilters(tempArr);
        getCatProducts(tempArr);
      } else {
        firstRender.current = false;
        let queries = catObject["QueryString"] || "";
        if (queries !== "") {
          let queryColorsArr = queries.split("colors=");
          queryColorsArr = queryColorsArr[1] ? queryColorsArr[1].split("&") : [];
          let queryColors = queryColorsArr[0] ? queryColorsArr[0] : "";
          let queryColorsSelected = queryColors.split(",").filter((n) => n)
            ? [...new Set(queryColors.split(","))].filter((n) => n)
            : [];
          setFilterColors(queryColorsSelected);

          let queryPatternsArr = queries.split("patterns=");
          queryPatternsArr = queryPatternsArr[1] ? queryPatternsArr[1].split("&") : [];
          let queryPatterns = queryPatternsArr[0] ? queryPatternsArr[0] : "";
          let queryPatternsSelected = queryPatterns.split(",").filter((n) => n)
            ? [...new Set(queryPatterns.split(","))].filter((n) => n)
            : [];
          setFilterPatterns(queryPatternsSelected);

          let queryTypesArr = queries.split("type=");
          queryTypesArr = queryTypesArr[1] ? queryTypesArr[1].split("&") : [];
          let queryTypes = queryTypesArr[0] ? queryTypesArr[0] : "";
          let queryTypesSelected = queryTypes.split(",").filter((n) => n)
            ? [...new Set(queryTypes.split(","))].filter((n) => n)
            : [];
          setFilterTypes(queryTypesSelected);
          let queryPricesArr = queries.split("price=");
          queryPricesArr = queryPricesArr[1] ? queryPricesArr[1].split("&") : [];
          let queryPrices = queryPricesArr[0] ? queryPricesArr[0] : "";
          let queryPricesSelected = queryPrices
            .split(",")
            .filter((n) => n)
            .map(decodeURIComponent)
            ? [...new Set(queryPrices.split(",").map(decodeURIComponent))].filter((n) => n)
            : [];

          setFilterPrices(queryPricesSelected);

          let queryOpacityArr = queries.split("opacity=");
          queryOpacityArr = queryOpacityArr[1] ? queryOpacityArr[1].split("&") : [];
          let queryOpacity = queryOpacityArr[0] ? queryOpacityArr[0] : "";
          let queryOpacitySelected = queryOpacity.split(",").filter((n) => n)
            ? [...new Set(queryOpacity.split(","))].filter((n) => n)
            : [];
          setFilterOpacity(queryOpacitySelected);

          let queryEndUseArr = queries.split("application=");
          queryEndUseArr = queryEndUseArr[1] ? queryEndUseArr[1].split("&") : [];
          let queryEndUse = queryEndUseArr[0] ? queryEndUseArr[0] : "";
          let queryEndUseSelected = queryEndUse.split(",").filter((n) => n)
            ? [...new Set(queryEndUse.split(","))].filter((n) => n)
            : [];
          setFilterEndUse(queryEndUseSelected);
          let querySizeArr = queries.split("size=");
          querySizeArr = querySizeArr[1] ? querySizeArr[1].split("&") : [];
          let querySize = querySizeArr[0] ? querySizeArr[0] : "";
          let querySizeSelected = querySize.split(",").filter((n) => n)
            ? [...new Set(querySize.split(","))].filter((n) => n)
            : [];
          setFilterProductSize(querySizeSelected);

          let queryHangingStyleArr = queries.split("hangingStyle=");
          queryHangingStyleArr = queryHangingStyleArr[1] ? queryHangingStyleArr[1].split("&") : [];
          let queryHangingStyle = queryHangingStyleArr[0] ? queryHangingStyleArr[0] : "";
          let queryHangingStyleSelected = queryHangingStyle.split(",").filter((n) => n)
            ? [...new Set(queryHangingStyle.split(","))].filter((n) => n)
            : [];
          setFilterHangingStyle(queryHangingStyleSelected);

          let queryObj = {
            colors: queryColorsSelected,
            patterns: queryPatternsSelected,
            type: queryTypesSelected,
            price: queryPricesSelected,
            opacity: queryOpacitySelected,
            ProductSize: querySizeSelected,
            hangingStyle: queryHangingStyleSelected,
            application: queryEndUseSelected,
          };
          const serialize = (obj) =>
            Object.keys(obj)
              .map((key) =>
                obj[key].length > 0 ? `${key}=${encodeURIComponent(obj[key].join("-"))}` : undefined
              )
              .filter((n) => n)
              .join("&");
          setSearchParams(serialize(queryObj));

          setBaseFilter(Object.keys(queryObj).find((key) => queryObj[key].length));
        } else {
          setSelectedFilters([]);
          getCatProducts([]);
        }
      }

      if (filterChangedBool) {
        setFilterChangedBool(false);
      } else {
        setShowAllFilters(false);
        setSelectedSort(undefined);
      }
    }
  }, [
    JSON.stringify(catObject),
    searchParams.get("colors"),
    searchParams.get("patterns"),
    searchParams.get("type"),
    searchParams.get("price"),
    searchParams.get("opacity"),
    searchParams.get("size"),
    searchParams.get("Lining"),
    searchParams.get("ProductSize"),
    searchParams.get("hangingStyle"),
    searchParams.get("application"),
  ]);

  useEffect(() => {
    if (pageLanguage !== "") {
      if (Object.keys(catProducts).length) {
        renderProducts();
      }
    }
  }, [pageLanguage, catProducts, selectedSort, filterColors, activeColor, columnCountWidth]);

  useEffect(() => {
    const changeColorKey = changeColor["key"];
    if (!changeColorKey) {
      return;
    }
    if (changeColor["carousel"]) {
      let nextItem = 0;
      let index = designColors[changeColorKey].indexOf(changeColor["id"]);
      if (index >= 0 && index < designColors[changeColorKey].length - 1) {
        nextItem = designColors[changeColorKey][index + 1];
      } else if (index === designColors[changeColorKey].length - 1) {
        nextItem = designColors[changeColorKey][0];
      }

      let temp = { ...activeColor };

      temp[changeColorKey] = nextItem;
      setActiveColor(temp);

      setChangeColor({
        key: undefined,
        id: undefined,
        carousel: undefined,
      });
    } else {
      let temp = { ...activeColor };
      temp[changeColorKey] = changeColor["id"];
      setActiveColor(temp);
      setChangeColor({
        key: undefined,
        id: undefined,
        carousel: undefined,
      });
    }
  }, [changeColor]);

  useEffect(() => {
    const prevPathParts = prevPathnameRef.current.split("/");
    const newPathParts = location.pathname.split("/");
    const prevCategoryPath = prevPathParts.slice(2).join("/");
    const newCategoryPath = newPathParts.slice(2).join("/");
    const isLanguageOnlyChange =
      prevCategoryPath === newCategoryPath &&
      prevPathParts[1] !== newPathParts[1] &&
      prevPathnameRef.current !== location.pathname;

    prevPathnameRef.current = location.pathname;
    routeRef.current = { pathname: location.pathname, catID };

    firstRender.current = true;
    const newLang = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    if (pageLanguage !== newLang) {
      setPageLanguage(newLang);
    }

    if (isLanguageOnlyChange) {
      return;
    }

    let queryObj = {
      colors: searchParams.get("colors")?.split("-") || [],
      patterns: searchParams.get("patterns")?.split("-") || [],
      type: searchParams.get("type")?.split("-") || [],
      price: searchParams.get("price")?.split("-") || [],
      opacity: searchParams.get("opacity")?.split("-") || [],
      size: searchParams.get("size")?.split("-") || [],
      Lining: searchParams.get("Lining")?.split("-") || [],
      ProductSize: searchParams.get("ProductSize")?.split("-") || [],
      hangingStyle: searchParams.get("hangingStyle")?.split("-") || [],
      application: searchParams.get("application")?.split("-") || [],
    };
    if (Object.keys(queryObj).every((key) => queryObj[key].length === 0)) {
      setSearchParams("");
    }
    setSelectedSort(undefined);
    setBaseFilter(undefined);
    setSelectedFilters(undefined);
    setCatObject({});
    setCatProducts({});
    setActiveColor({});
    setDesignColors({});
    setFilterColors([]);
    setFilterPatterns([]);
    setFilterTypes([]);
    setFilterPrices([]);
    setFilterOpacity([]);
    setFilterSize([]);
    setFilterLiningType([]);
    setFilterProductSize([]);
    setFilterHangingStyle([]);
    setFilterMaterial([]);
    setFilterEndUse([]);
    setSelectedFiltersList([]);
    setCatProductsList([]);
    setProductFilters({});
    setFilterChangedBool(false);
    setShowAllFilters(false);
    setShowMoreFilter({
      colors: false,
      patterns: false,
      type: false,
      price: false,
      opacity: false,
      size: false,
      Lining: false,
      hangingStyle: false,
      Material: false,
      ProductSize: false,
      application: false,
    });
  }, [location.pathname]);

  useScrollToTopOnPageLoad(pageLanguage, getCats, location);
  useHandleScrollEvents(isTabletOrMobile, fixedDiv2, setOffset);
  return (
    <div className={`Product_page_container ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}>
      <div className="Product_page_top_sticky" ref={fixedDiv2}>
        <div className="Product_page_header">
          <h1>
            {pageLanguage === "en" ? catObject["EnTitle"] : convertToPersian(catObject["Title"])}
          </h1>
        </div>
        <div className="Product_page_filters_fix_container">
          <div className="Product_page_filters_container">
          <div className="Product_page_filters">
            <div className="filters_container filters_container_show">
              <div className="filter_container filter_container_all_filter">
                <div title="" className="dropdown">
                  <button
                    aria-expanded="false"
                    type="button"
                    className="dropdown_btn dropdown-toggle btn btn-primary"
                    onClick={() => setShowAllFilters(!showAllFilters)}
                  >
                    {(!showAllFilters || isTabletOrMobile) && <p>{t("Filters")}</p>}
                    {showAllFilters && !isTabletOrMobile && <p>{t("Hide Filters")}</p>}
                    <div className="select_control_all_filters img-fluid"></div>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="Product_page_sort">
            <div className="filters_container filters_container_items_num">
              {!!catProductsList.filter((item) => item.type === "li").length && (
                <p>
                  {NumToFa(
                    catProductsList.filter((item) => item.type === "li").length,
                    pageLanguage
                  )}
                  &nbsp;
                  {t("product_Items")}
                </p>
              )}
            </div>

            <div className="Product_page_sort_select 3">
              <div className="sort_dropdown_container">
                <Dropdown autoClose="outside" title="" align="end">
                  <Dropdown.Toggle className="dropdown_btn">
                    <label className="select_label">{t("Sort By: ")}</label>
                    {selectedSort !== undefined && <p>{t(selectedSort)}</p>}
                    <div className="select_control_handle_close img-fluid" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="filter_color_items">
                    <Dropdown.Item as={Button} onClick={() => setSelectedSort("New")}>
                      <label className="radio_style">
                        <input
                          className="radio"
                          type="radio"
                          name="sort"
                          id="sort1"
                          checked={selectedSort === "New"}
                        />
                        <label htmlFor="sort1">{t("New")}</label>
                      </label>
                    </Dropdown.Item>
                    <Dropdown.Item
                      as={Button}
                      onClick={() => setSelectedSort("Price, High to Low")}
                    >
                      <label className="radio_style">
                        <input
                          className="radio"
                          type="radio"
                          name="sort"
                          id="sort2"
                          checked={selectedSort === "Price, High to Low"}
                        />
                        <label htmlFor="sort2">{t("Price, High to Low")}</label>
                      </label>
                    </Dropdown.Item>
                    <Dropdown.Item
                      as={Button}
                      onClick={() => setSelectedSort("Price, Low to High")}
                    >
                      <label className="radio_style">
                        <input
                          className="radio"
                          type="radio"
                          name="sort"
                          id="sort3"
                          checked={selectedSort === "Price, Low to High"}
                        />
                        <label htmlFor="sort3">{t("Price, Low to High")}</label>
                      </label>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>

          <div className="filters_container flex_grow 2">
            <div
              className={
                showAllFilters
                  ? "filters_hidden_part filters_hidden_part_extended"
                  : "filters_hidden_part"
              }
            />
            <ul>{selectedFiltersList}</ul>
          </div>
        </div>
      </div>
      </div>

      <div className="Product_page_body_container">
        <div
          className={
            showAllFilters
              ? "Product_page_body_filters_container desktop_only 1"
              : "Product_page_body_filters_container desktop_only hidden 2"
          }
        >
          <div
            className={
              isTabletOrMobile
                ? offset
                  ? "product_filters_container product_filters_container_fixed"
                  : "product_filters_container 2"
                : offset
                ? "product_filters_container product_filters_container_fixed"
                : "product_filters_container 3"
            }
            ref={fixedDiv}
          >
            {!!sewingOpacity2.length && (
              <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Opacity")}
                    textOnShow={t("Opacity")}
                  />
                  <Accordion.Body className="product_filter_dropdown">
                    <div className="product_filter_dropdown">{sewingOpacity2}</div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
            {!!sewingTypes2.length && (
              <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Type")}
                    textOnShow={t("Type")}
                  />
                  <Accordion.Body className="product_filter_dropdown">
                    <div className="product_filter_dropdown">{sewingTypes2}</div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
            {!!sewingPatterns2.length && (
              <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Pattern")}
                    textOnShow={t("Pattern")}
                  />
                  <Accordion.Body className="product_filter_dropdown">
                    <div className="product_filter_dropdown">{sewingPatterns2}</div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
            {!!sewingColors2.length && (
              <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Color")}
                    textOnShow={t("Color")}
                  />
                  <Accordion.Body className="product_filter_dropdown">
                    <div className="product_filter_dropdown">{sewingColors2}</div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
    
            {!!sewingHangingStyle2.length  &&
              location.pathname.split("/")[2] !== "Ready-Made-Shade" && 
              !["ready-made-zebra", "ready-made-dual-roller-shade", "ready-made-roller-shade"].includes(location.pathname.split("/")[3]) &&  (
                <Accordion defaultActiveKey={"0"}>
                  <Accordion.Item eventKey="1">
                    <ContextAwareToggleFilters
                      eventKey="1"
                      textOnHide={location.pathname.split("/")[2] === "ready-made-drapery" ? t("Header Style") : t("Shade Style")}
                      textOnShow={location.pathname.split("/")[2] === "ready-made-drapery" ? t("Header Style") : t("Shade Style")}
                    />
                    <Accordion.Body className="product_filter_dropdown">
                      <div className="product_filter_dropdown">{sewingHangingStyle2}</div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              )}
            {!!sewingSize2.length && (
              <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Size")}
                    textOnShow={t("Size")}
                  />
                  <Accordion.Body className="product_filter_dropdown">
                    <div className="product_filter_dropdown">{sewingSize2}</div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
            {!!sewingLiningType.length && (
              <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Lining Type")}
                    textOnShow={t("Lining Type")}
                  />
                  <Accordion.Body className="product_filter_dropdown">
                    <div className="product_filter_dropdown">{sewingLiningType}</div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
            {!!sewingEndUse2.length && (
              <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Application")}
                    textOnShow={t("Application")}
                  />
                  <Accordion.Body className="product_filter_dropdown">
                    <div className="product_filter_dropdown">{sewingEndUse2}</div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
            {!!sewingPrices2.length && (
              <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Price")}
                    textOnShow={t("Price")}
                  />
                  <Accordion.Body className="product_filter_dropdown">
                    <div className="product_filter_dropdown">{sewingPrices2}</div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
          </div>
        </div>
        <div className="Product_page_body_products_container 3">
          <ul className="products_list">{catProductsList}</ul>
        </div>
        <div
          className={
            showAllFilters
              ? "Product_page_body_filters_container mobile_only filter_open"
              : "Product_page_body_filters_container mobile_only"
          }
        >
          <div className="nav_header">
            <div className="nav_header_bottom nav_header_bottom_single">
              <div className="close_menu_icon" onClick={() => setShowAllFilters(false)}>
                <img
                  src={require("../Images/public/close-button.png")}
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="product_filters_container 4">
            {!!sewingOpacity2.length && (
              <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Opacity")}
                    textOnShow={t("Opacity")}
                  />
                  <Accordion.Body className="product_filter_dropdown">
                    <div className="product_filter_dropdown">{sewingOpacity2}</div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
              {!!sewingTypes2.length && (
              <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Type")}
                    textOnShow={t("Type")}
                  />
                  <Accordion.Body className="product_filter_dropdown">
                    <div className="product_filter_dropdown">{sewingTypes2}</div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
            {!!sewingPatterns2.length && (
              <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Pattern")}
                    textOnShow={t("Pattern")}
                  />
                  <Accordion.Body className="product_filter_dropdown">
                    <div className="product_filter_dropdown">{sewingPatterns2}</div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
            {!!sewingColors2.length && (
              <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Color")}
                    textOnShow={t("Color")}
                  />
                  <Accordion.Body className="product_filter_dropdown">
                    <div className="product_filter_dropdown">{sewingColors2}</div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
            {false && (
              <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Size")}
                    textOnShow={t("Size")}
                  />
                  <Accordion.Body className="product_filter_dropdown">
                    <div className="product_filter_dropdown"></div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
          
            {!!sewingTypes2.length && (
              <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Type")}
                    textOnShow={t("Type")}
                  />
                  <Accordion.Body className="product_filter_dropdown">
                    <div className="product_filter_dropdown">{sewingTypes2}</div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
          
            {!!sewingHangingStyle2.length && (
              <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={location.pathname.split("/")[2] === "ready-made-drapery" ? t("Header Style") : t("Shade Style")}
                    textOnShow={location.pathname.split("/")[2] === "ready-made-drapery" ? t("Header Style") : t("Shade Style")}
                  />
                  <Accordion.Body className="product_filter_dropdown">
                    <div className="product_filter_dropdown">{sewingHangingStyle2}</div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
               {!!sewingSize2.length && (
              <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Size")}
                    textOnShow={t("Size")}
                  />
                  <Accordion.Body className="product_filter_dropdown">
                    <div className="product_filter_dropdown">{sewingSize2}</div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
            {!!sewingLiningType.length && (
              <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Lining Type")}
                    textOnShow={t("Lining Type")}
                  />
                  <Accordion.Body className="product_filter_dropdown">
                    <div className="product_filter_dropdown">{sewingLiningType}</div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
            {!!sewingEndUse2.length && (
              <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Application")}
                    textOnShow={t("Application")}
                  />
                  <Accordion.Body className="product_filter_dropdown">
                    <div className="product_filter_dropdown">{sewingEndUse2}</div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
              {!!sewingPrices2.length && (
              <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Price")}
                    textOnShow={t("Price")}
                  />
                  <Accordion.Body className="product_filter_dropdown">
                    <div className="product_filter_dropdown">{sewingPrices2}</div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}
          </div>
        </div>
      </div>
      <div className="product_page_bottom" ref={fixedDiv3} />
    </div>
  );
}

export default ProductsTowel;